<script lang="ts">
  import { avatarColour, initials } from '../lib/format';
  import { app, type Presence } from '../lib/stores.svelte';

  let {
    user,
    size = 36,
    presence,
  }: { user: { id: string; display_name: string; avatar_url?: string | null }; size?: number; presence?: Presence } =
    $props();

  const url = $derived(app.avatarOf(user));
  let failed = $state<string | null>(null);
</script>

<span class="avatar" style:width="{size}px" style:height="{size}px" aria-hidden="true">
  {#if url && failed !== url}
    <img class="face photo" src={url} alt="" width={size} height={size} loading="lazy" onerror={() => (failed = url)} />
  {:else}
    <span class="face" style:background={avatarColour(user.id)} style:font-size="{Math.round(size * 0.36)}px">
      {initials(user.display_name)}
    </span>
  {/if}
  {#if presence === 'online'}
    <span class="dot" title="En ligne"></span>
  {/if}
</span>

<style>
  .avatar {
    position: relative;
    flex: 0 0 auto;
    display: inline-flex;
  }
  .face {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    color: #ffffff;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.02em;
  }
  .photo {
    object-fit: cover;
    background: var(--bg-page);
  }
  .dot {
    position: absolute;
    right: -2px;
    bottom: -2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--online);
    border: 2px solid var(--bg-sidebar);
  }
</style>
